import { getApiUrl, RECRUITER_API_URL } from '../../util/api/api'
import type { UserInfoOutgoing } from '../../../state/reducers/user/user'
import { StatusCodes } from 'http-status-codes'

const updateRecruiterInfo = async (data: UserInfoOutgoing) => {
  const fetchResponse = await fetch(
    getApiUrl(RECRUITER_API_URL), {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      credentials: 'include',
      body: JSON.stringify(data),
    }
  )
  
  if (fetchResponse?.ok) {
    return Promise.resolve({ status: StatusCodes.ACCEPTED })
  }
  if (!fetchResponse) return Promise.reject(null)

  const correlationId = fetchResponse.headers?.get('x-correlation-id') || undefined
  return Promise.reject({
    status: fetchResponse.status,
    data: fetchResponse.statusText,
    ...(correlationId && { correlationId }),
  })
}
export default updateRecruiterInfo
